import { cn } from '@util/index';
import Link from 'next/link';

const PageSectionHeader = ({
  title,
  linkText,
  href,
  target,
  variant = 'default',
  titleClassName,
  subtitle,
}: {
  title: string;
  href?: string;
  target?: string;
  linkText?: string;
  variant?: 'default' | 'secondary' | 'centered';
  titleClassName?: string;
  subtitle?: string;
}) => {
  return variant === 'default' ? (
    <div
      className={`flex ${
        linkText ? 'w-full' : 'w-fit'
      } flex-wrap items-center justify-between px-8 sm:px-0`}
    >
      <div className="flex flex-col items-start gap-2 sm:flex-row sm:items-center sm:gap-6">
        <h2
          className={cn(
            'text-[2.4rem] font-semibold text-inherit sm:text-[3rem]',
            titleClassName
          )}
        >
          {title}
        </h2>

        {!!subtitle && (
          <div className="hidden h-[3rem] w-px bg-brand-light-gray sm:block" />
        )}

        {!!subtitle && (
          <span className="text-[2.1rem] font-medium text-zinc-400 sm:text-zinc-600">
            {subtitle}
          </span>
        )}
      </div>

      {linkText && href && (
        <Link
          href={href}
          target={target ?? '_self'}
          className="transition-color text-[1.6rem] font-semibold text-brand-secondary transition-colors hover:text-brand-primary sm:text-[2rem]"
        >
          {linkText}
        </Link>
      )}
    </div>
  ) : variant === 'secondary' ? (
    <div className="mb-[2.4rem] items-center sm:mb-[4rem] sm:flex sm:justify-between">
      <h2 className="mx-auto mb-[1.6rem] block w-fit text-center text-[2.4rem] font-semibold sm:m-0 sm:inline-block sm:text-[3.2rem]">
        {title}
      </h2>
      <div className="mx-auto block w-fit text-center sm:m-0 sm:inline-block">
        {linkText !== '' && href !== '' && (
          <Link
            href={href ?? ''}
            className="transition-color font-semibold text-brand-secondary transition-colors hover:text-brand-primary"
          >
            {linkText}
          </Link>
        )}
      </div>
    </div>
  ) : (
    <div className="flex w-full items-start justify-center px-8 sm:mx-auto sm:max-w-content">
      <div className="flex flex-col items-center gap-y-8">
        <h2 className="mb-[1.6rem] block w-fit text-center text-[2.4rem] font-semibold sm:m-0 sm:inline-block sm:text-[3.2rem]">
          {title}
        </h2>
        <div className="hidden sm:block">
          {linkText && href && (
            <Link
              href={href}
              className="transition-color font-semibold text-brand-secondary transition-colors hover:text-brand-primary"
            >
              {linkText}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default PageSectionHeader;
